// DialogEditInvoicePeriod Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'

class DialogEditInvoicePeriod extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      fromDate: null,
      toDate: null
    }

    this._references = {
      fromDate: React.createRef(),
      toDate: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null
    }
  }

  show (fromDate, toDate) {
    this.setState({ active: true, fromDate, toDate })
  }

  hide () {
    this.setState({ active: false, fromDate: null, toDate: null })
  }

  render () {
    const { active, fromDate, toDate } = this.state

    return (
      <Dialog active={active} onClose={this.hide.bind(this)}>
        <div className='dialog-form invoiceeditperiod-form'>
          <div className='dialogform-header'>
            <div className='title'>
              <IntlMessage ident='invoice.form.editPeriodTitle' />
              <div className='subinfo'>
                <IntlMessage ident='invoice.form.editPeriodTitleInfo' />
              </div>
            </div>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          ref={this._references.fromDate}
                          label='invoice.form.editPeriodFromDate'
                          placeholder='invoice.form.editPeriodFromDate'
                          value={fromDate}
                          name='fromDate'
                          onChange={this._onChangeDate.bind(this, 'fromDate')}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          ref={this._references.toDate}
                          label='invoice.form.editPeriodToDate'
                          placeholder='invoice.form.editPeriodToDate'
                          value={toDate}
                          name='toDate'
                          onChange={this._onChangeDate.bind(this, 'toDate')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='invoice.form.editPeriodSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0
    const { fromDate, toDate } = this.state

    if (
      this._references.fromDate.current &&
      (!this._references.fromDate.current.validate() || !fromDate)
    ) {
      noErrors++
    }

    if (
      this._references.toDate.current &&
      (!this._references.toDate.current.validate() || !toDate)
    ) {
      noErrors++
    }

    if (noErrors === 0 && this.props.onSubmit) {
      this.props.onSubmit(fromDate, toDate)
    }
  }

  _onChangeDate (name, value) {
    this.setState({ [name]: value })
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }
}

export default DialogEditInvoicePeriod
